import { ConfigProvider } from "antd";
import { Provider } from "react-redux";
import { theme } from "./constants/theme";
import "./styles/base.scss";
import store from "./store";
import { BrowserRouter } from "react-router-dom";
import AppRouter from "./routes/AppRouter";
import NotificationStack from "./components/NotificationStack";
import { useNotificationListener } from "./hooks/useNotificationListener";
import { useVersionCheck } from "./hooks/useVersionCheck";
import { useAppBadge } from "./hooks/useAppBadge";
import { useServiceWorkerNavigation } from "./hooks/useServiceWorkerNavigation";
import { usePWAContextMenu } from "./hooks/usePWAContextMenu";
import { VersionCheckProvider } from "./contexts/VersionCheckContext";
import UpdateBanner from "./components/UpdateBanner";
import PWAInstallPrompt from "./components/PWAInstallPrompt/PWAInstallPrompt";
import NotificationTester from "./components/NotificationTester";
import PWAOfflineGate from "./components/OfflinePage/PWAOfflineGate";
// import ErrorBoundary from "./components/ErrorBoundary";

// Expose store for debugging in development
if (import.meta.env.DEV) {
  (window as any).__REDUX_STORE__ = store;
}

// changes are comented to be implemented later

const AppContent = () => {
  useNotificationListener();
  useVersionCheck();
  useAppBadge(); // Sync app badge with new orders count
  useServiceWorkerNavigation(); // Handle navigation from service worker
  usePWAContextMenu(); // Disable right-click in PWA mode

  return (
    <PWAOfflineGate>
      <UpdateBanner />
      <PWAInstallPrompt />
      <div id="app">
        <AppRouter />
      </div>
      <NotificationStack />
      <NotificationTester />
    </PWAOfflineGate>
  );
};

function App() {
  return (
    // <ErrorBoundary>
    <Provider store={store}>
      <ConfigProvider theme={theme}>
        <BrowserRouter>
          <VersionCheckProvider>
            <AppContent />
          </VersionCheckProvider>
        </BrowserRouter>
      </ConfigProvider>
    </Provider>
    // </ErrorBoundary>
  );
}

export default App;
